import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { addRouteNamespace } from '@Utils/actions';
import { VALUEMAPPING_ROUTES } from '@Types/routes';

type SensorsRedirectsReturn = {
	//
	redirectToCreatePage(): void;
};

export const useValuemappingRedirects = (): SensorsRedirectsReturn => {
	const history = useHistory();

	return useMemo(() => {
		const redirectToHandler = (route: string) => (): void => {
			history.push(addRouteNamespace(route));
		};

		const redirectToCreateProfilePage = redirectToHandler(
			VALUEMAPPING_ROUTES.create,
		);

		return {
			redirectToCreatePage: redirectToCreateProfilePage,
		};
	}, []);
};

export default useValuemappingRedirects;
